import {
  useGetMyCurrentCallerIdQuery,
  useLazyGetMyCallerIdsQuery,
  useUpdateMyCallerIdMutation,
} from "@/services/softphone";
import { FC, useEffect } from "react";
import { Form, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

const WebphoneSettings: FC = () => {
  const { data: current, isLoading: isCurrentLoading } =
    useGetMyCurrentCallerIdQuery(undefined, {
      pollingInterval: 5000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    });
  const [fetchCallerIds, { data: callerIds, isLoading: isListLoading }] =
    useLazyGetMyCallerIdsQuery();
  const [updateCallerId, { isLoading: isUpdating }] =
    useUpdateMyCallerIdMutation();

  useEffect(() => {
    fetchCallerIds();
  }, [fetchCallerIds]);

  const onChange = (number: string) => {
    if (!number || number === current?.number) return;
    toast.promise(updateCallerId(number).unwrap(), {
      pending: "Mise à jour du numéro de présentation...",
      success: "Numéro de présentation mis à jour",
      error: "Impossible de changer le numéro de présentation",
    });
  };

  const isLoading = isCurrentLoading || isListLoading;

  return (
    <div className="px-3 pb-3">
      <p className="fs--1 text-body-secondary mb-2">Numéro de présentation</p>
      {isLoading ? (
        <div className="d-flex justify-content-center py-3">
          <Spinner animation="border" size="sm" />
        </div>
      ) : callerIds && callerIds.length > 0 ? (
        <Form.Select
          value={current?.number ?? ""}
          disabled={isUpdating}
          onChange={(e) => onChange(e.target.value)}
        >
          {!current?.number && <option value="">Choisir un numéro…</option>}
          {callerIds.map((callerId) => (
            <option key={callerId.number} value={callerId.number}>
              {callerId.number}
              {callerId.code ? ` (${callerId.code})` : ""}
            </option>
          ))}
        </Form.Select>
      ) : (
        <p className="fs--1 text-body-tertiary mb-0">
          Aucun numéro de présentation disponible pour cette ligne.
        </p>
      )}
    </div>
  );
};

export default WebphoneSettings;
